import { Card, CardBody, Col } from "reactstrap";
import { WithoutShadowTitle } from "../../../constants";
import { WithoutShadowSubTitle } from "../../../data/bonusUi/BasicCard";
import { dynamicImage } from "../../../utils";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { Image } from "../../../coreComponents/Image";

const WithoutShadow = () => {
  return (
    <Col sm="12" xl="6">
      <Card className="border">
        <CommonCardHeader title={WithoutShadowTitle} span={WithoutShadowSubTitle} />
        <CardBody>
          <div className="flex-space align-items-center">
            <Image className="tab-img img-fluid" src={dynamicImage(`avtar/3.jpg`)} alt="profile" />
            <p>
              <strong>{"Visit Us: "}</strong>
              {"2600 Hollywood Blvd,Florida, United States-33020"}
              <br />
              <strong>{"Mail Us:"}</strong>
              {"contact@us@gmail.com"}
              <br />
              <strong>{"Contact Number: "}</strong>
              {"(954) 357-7760"}
            </p>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default WithoutShadow;
